import { SetDeptService } from './set-dept.service';
import { Component, OnInit } from '@angular/core';
import { CurrentService, eleSwitchDept } from 'dbweb-core';
import { MatDialogRef } from '@angular/material/dialog';
import { ElementsService } from 'dbweb-core';
import { FormControl, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
	selector: 'common-set-dept',
	templateUrl: './set-dept.component.html',
	styleUrls: ['./set-dept.component.css']
})
export class SetDeptComponent implements OnInit {
	constructor(
		public dialogRef: MatDialogRef<SetDeptComponent>,
		public current: CurrentService,
		private eles: ElementsService,
		private setDeptService: SetDeptService
	) {
		const This = this;
		this.newCode = new FormControl(
			this.current.data.Dept.Code,
			[
				Validators.required,
				(control: AbstractControl): ValidationErrors | null => {
					if (!control.value.startsWith(This.current.data.UserDept.Code)) {
						return { owner: true };
					}
					return null;
				}
			],
			(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> =>
				setDeptService.codeExists(control.value).pipe(map(v => (v ? null : { exists: true })))
		);
		this.newCode.markAsTouched();
	}
	newCode: FormControl;
	getErrorMessage() {
		return this.newCode.hasError('required')
			? 'ä½ å¿é¡»å½å¥ä¸ä¸ªä»£ç '
			: this.newCode.hasError('owner')
			? `å¿é¡»ä»¥ ${this.current.data.UserDept.Code} å¼å¤´`
			: this.newCode.hasError('exists')
			? `ä»£ç  ${this.newCode.value} ä¸å­å¨`
			: '';
	}
	ngOnInit() {}

	clickOk() {
		this.current
			.switchDept(this.newCode.value, this.eles.get(eleSwitchDept).SignStr)
			.subscribe(() => this.dialogRef.close());
	}
	codeEnter() {
		if (!this.newCode.invalid) {
			this.clickOk();
		}
	}
}
